import { render, staticRenderFns } from "./NotificationBody.vue?vue&type=template&id=4b5e4d01"
import script from "./NotificationBody.vue?vue&type=script&lang=js"
export * from "./NotificationBody.vue?vue&type=script&lang=js"
import style0 from "./NotificationBody.vue?vue&type=style&index=0&id=4b5e4d01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports